import { getAccessControlsRpc } from '../../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService';
import { rpcClient } from '../../http/rpcClient';
export const fetchAiSettings = () => {
  return rpcClient.call(getAccessControlsRpc, {});
};